export const CONTENT_CARD_IMAGE_HEIGHT_MOBILE = 102;
export const CONTENT_CARD_IMAGE_HEIGHT_DESKTOP = 124;
export const HERO_BANNER_IMAGE_MAX_WIDTH_MOBILE = 310;
export const HERO_BANNER_IMAGE_MAX_WIDTH_TABLET = 354;
export const HERO_BANNER_IMAGE_MAX_WIDTH_DESKTOP = 452;
